
const KSClientPdfSplit = ({
    className,
    src,
    alt,
    title,
    body,
    footer,
    ...props
}) => {
    
    return (
        
        <div
            className={`card bg-base-100 w-full shadow-xl cursor-pointer
                border-2 border-transparent hover:border-accent ${className}`}
            {...props}>
            
            <figure>
                {!src && (
                    <div className="w-full h-auto bg-base-200 rounded-md" />
                )}
                {src && (<img
                    width="100%"
                    height="auto"
                    src={src}
                    alt={alt ?? ''} />)}
            </figure>
            
            <div className="card-body p-3">
                
                {title && (
                    <h4 className="card-title text-base font-normal">
                        {title}
                    </h4>
                )}
                
                {body && (<p>{body}</p>)}
                
                {footer && (
                    <div className="card-actions justify-end">
                        {/* <button className="btn btn-primary">Buy Now</button> */}
                        {footer}
                    </div>
                )}
            </div>
        
        </div>
        
    )
    
}

export default KSClientPdfSplit
